import styled from 'styled-components'
import { sizeMobile } from 'components/globalStyles'

export const MenuContainer = styled.div`
  display: none;

  @media (max-width: ${sizeMobile}) {
    position: fixed;
    top: 0;
    left: 0;
    height: 64px;
    width: 100vw;
    background: white;
    display: grid;
    grid-template-columns: 64px 1fr 64px;
    justify-items: center;
    align-items: center;

    & button {
      height: 100%;
      font-size: 2.2rem;
    }
  }
`
